/* eslint-disable */
import React, { FC } from 'react';
import { Line, Path, Rect, Svg } from '@react-pdf/renderer';
import { EScore, EScoreRating } from '../../../../../services/individualReport';
import { THEME as theme } from '../../../../../styles/theme';

const bar: Record<EScore, string> = {
  [EScore.LOW]:
    'M0 4C0 1.79086 1.79086 0 4 0H84C86.2091 0 88 1.79086 88 4V12C88 14.2091 86.2091 16 84 16H4C1.79086 16 0 14.2091 0 12V4Z',
  [EScore.NORMAL]:
    'M0 4C0 1.79086 1.79086 0 4 0H172C174.209 0 176 1.79086 176 4V12C176 14.2091 174.209 16 172 16H4C1.79086 16 0 14.2091 0 12V4Z',
  [EScore.HIGH]:
    'M0 4C0 1.79086 1.79086 0 4 0H260C262.209 0 264 1.79086 264 4V12C264 14.2091 262.209 16 260 16H4C1.79086 16 0 14.2091 0 12V4Z',
};

const colors: Record<EScoreRating, string> = {
  [EScoreRating.WEAK]: theme.colors.accent.red[100],
  [EScoreRating.NORMAL]: theme.colors.accent.blue[100],
  [EScoreRating.STRONG]: theme.colors.accent.green[100],
};

interface IProgressBar {
  score: EScore;
  score_rating: EScoreRating;
}

const ProgressBar: FC<IProgressBar> = ({ score, score_rating }) => (
  <Svg width="264" height="16" viewBox="0 0 264 16" fill="none">
    <Rect
      x="0.5"
      y="0.5"
      width="263"
      height="15"
      rx="3.5"
      ry="3.5"
      fill={theme.colors.neutral.primary[10]}
      stroke={theme.colors.neutral.primary[30]}
    />
    <Path d={bar[score]} fill={colors[score_rating]} />
    {score === 'low' && (
      <Line x1="88.5" y1="16" x2="88.5" y2="0" stroke={theme.colors.neutral.primary[30]} />
    )}
    {score !== 'high' && (
      <Line x1="176.5" y1="16" x2="176.5" y2="0" stroke={theme.colors.neutral.primary[30]} />
    )}
  </Svg>
);

export default ProgressBar;
